import {Component, Input} from '@angular/core'

@Component({
  selector: 'pop-card',
  styles: [`
    :host {
      display: block;
      position: absolute;
    }
    .pop-card-modal {
      z-index: 1000;

      position: fixed;
      top: calc(5% + 50px);
      left: 50%;
      transform: translateX(-50%);

      width: 95%;
      padding: 0;
      bottom: 5%;
      overflow: auto;
    }

    @media(min-width: 768px) {
      .pop-card-modal {
        position: relative;
        top: 0;
        left: 0;
        transform: none;

        width: inherit;
      }
    }
  `],
  template: `
    <mat-card class="pop-card-modal" [ngStyle]="customStyle">
      <ng-content></ng-content>
    </mat-card>
  `
})
export class PopCardComponent {
  @Input() customStyle: object;
}
